import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { TopBar, TopBarEditor, TopBarSwitcher } from '@sloyd/ui';
import { useMemo } from 'react';
import { invokeEvent } from 'shared-base';
import p from '../../package.json';

export type TopBarContainerProps = {
  callbacks: {
    onLogoClick: () => void;
    onNavigate: (path: string) => void;
    onAction: OnAction;
    toggleLogs: () => void;
  };
};

export function TopBarContainer(props: TopBarContainerProps) {
  const dispatch = useDispatch();
  const topBar = useSelector(selectors.bars.$topBar);
  const { showLogs } = useSelector(selectors.raw.$rawAppState);
  const settings = useSelector(selectors.raw.$rawSettings);

  const callbacks = useMemo(
    () => ({
      onLogoClick: () => {
        invokeEvent('navToHome');
      },
      onNavigate: (path: string) => {
        invokeEvent('nav', { path });
      },
      onAction: (action: Action) => {
        dispatch(action);
      },
      toggleLogs: () => {
        dispatch(actions.appState.patch({ showLogs: !showLogs }));
      },
    }),
    [showLogs]
  );

  return (
    <TopBarSwitcher currentBarIndex={topBar.topBarIndex}>
      <TopBar data={topBar} version={p.version} callbacks={callbacks} />
      <TopBarEditor data={topBar} version={p.version} callbacks={callbacks}></TopBarEditor>
    </TopBarSwitcher>
  );
}
